import React from "react";
import GoogleMapReact from 'google-map-react';
import CustomMarker from "./CustomMarker";
import { useEffect } from "react";
import { useState } from "react";


export default function CustomGoogleMap({ places }) {

    const [defaultProps, setDefaultProps] = useState({
        center: {
            lat: 9.0765,
            lng: 7.3986
        },
        zoom: 7
    })


    useEffect(() => {

        if (places != null && places.length > 0 && places[0] != null) {
            setDefaultProps({
                center: {
                    lat: parseInt(places[0].lat),
                    lng: parseInt(places[0].lng)
                },
                zoom: 7
            })
        }
    }, [])

    return (
        // Important! Always set the container height explicitly
        <div style={{ height: '100%', width: '100%' }}>
            <GoogleMapReact

                bootstrapURLKeys={{
                    key: "AIzaSyBScbgs4z1n-iFG_-L00mpoz35-Lj46UFc",
                    language: "en",
                    region: "en"
                }}
                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
            >

                {places.map(place => {
                    if (place == null) return null;
                    return <CustomMarker
                        lat={place.lat}
                        lng={place.lng}
                        markerData={place.markerData}
                    />
                })}

            </GoogleMapReact>
        </div>
    );
}









// import React from 'react'
// import GoogleMapReact from 'google-map-react';



// // Marker component
// const Marker = ({ show, place }) => {
//     const markerStyle = {
//         border: '1px solid white',
//         borderRadius: '50%',
//         height: 10,
//         width: 10,
//         backgroundColor: show ? 'red' : 'blue',
//         cursor: 'pointer',
//         zIndex: 10,
//     };

//     return (
//         <>
//             <div style={markerStyle} />
//             {show && <InfoWindow place={place} />}
//         </>
//     );
// };

// function CustomGoogleMap({ places }) {


//     // onChildClick callback can take two arguments: key and childProps
//     const onChildClickCallback = (key) => {
//         // this.setState((state) => {
//         //     const index = state.places.findIndex((e) => e.id === key);
//         //     state.places[index].show = !state.places[index].show; // eslint-disable-line no-param-reassign
//         //     return { places: state.places };
//         // });
//         console.log("Google map child click");
//     };

//     return (
//         <>
//             {!isEmpty(places) && (
//                 <GoogleMapReact
//                     defaultZoom={10}
//                     defaultCenter={LOS_ANGELES_CENTER}
//                     bootstrapURLKeys="AIzaSyBScbgs4z1n-iFG_-L00mpoz35-Lj46UFc"
//                     onChildClick={this.onChildClickCallback}
//                 >
//                     {places.map((place) => (
//                         <Marker
//                             key={place.id}
//                             lat={place.geometry.location.lat}
//                             lng={place.geometry.location.lng}
//                             show={place.show}
//                             place={place}
//                         />
//                     ))}
//                 </GoogleMapReact>
//             )}
//         </>
//     )
// }

// export default CustomGoogleMap